import { Body } from "@sprout/typography";

export type DetailRow = {
  label: string;
  value?: string | null;
};

type Props = {
  rows: DetailRow[];
};

const SectionDetailList = ({ rows }: Props) => {
  const filled = rows.filter((row) => row.value?.trim());

  if (filled.length === 0) return null;

  return (
    <dl className="flex flex-col">
      {filled.map(({ label, value }) => (
        <div key={label} className="flex flex-wrap items-baseline gap-x-3">
          <dt>
            <Body as="span" metadata>
              {label}
            </Body>
          </dt>
          <dd className="m-0 min-w-0">
            <Body as="span">{value}</Body>
          </dd>
        </div>
      ))}
    </dl>
  );
};

export default SectionDetailList;
